import { render, staticRenderFns } from "./ImageCaptcha.vue?vue&type=template&id=1080c48a&lang=pug"
import script from "./ImageCaptcha.vue?vue&type=script&lang=js"
export * from "./ImageCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports